import breakpoints from "../../compara-ui/config/theme/breakpoints";
import { useEffect, useState } from "react";
var DEFAULT_MOBILE_WINDOW_SIZE = {
    width: 375,
    height: 812,
    isMobile: true,
    isDesktop: false,
};
export function useWindowSize() {
    var _a = useState(DEFAULT_MOBILE_WINDOW_SIZE), windowSize = _a[0], setWindowSize = _a[1];
    var handleResize = function () {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
            isMobile: window.innerWidth < breakpoints.md,
            isDesktop: window.innerWidth >= breakpoints.md,
        });
    };
    useEffect(function () {
        if (typeof window !== "undefined") {
            handleResize();
            window.addEventListener("resize", handleResize);
            return function () { return window.removeEventListener("resize", handleResize); };
        }
    }, []);
    return windowSize;
}
//# sourceMappingURL=useWindowSize.js.map